import type { PayloadAction } from '@reduxjs/toolkit';
import type { CampaignEditorReducerCreator } from '../types';
import { updateBlock } from '../helpers';

const updateBlockValue = (create: CampaignEditorReducerCreator) =>
  create.reducer((state, action: PayloadAction<{ blockId: string; value: string }>) => {
    const { blockId, value } = action.payload;
    updateBlock(state, blockId, (block) => ({ ...block, props: { ...block.props, value } }));
  });

export default updateBlockValue;
